var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main-dates",attrs:{"id":"datos"}},[_c('img',{staticClass:"desktop-image",attrs:{"src":"https://g.delfi.lt/glt/p/portal-custom-pages/prezidento-rinkimai/datos@2x.png"}}),_c('img',{staticClass:"mobile-image",attrs:{"src":"https://g.delfi.lt/glt/p/portal-custom-pages/prezidento-rinkimai/datos-mobile@2x.png"}})])
}]

export { render, staticRenderFns }